import { mockBtcEvmChainId } from '../config/btc';
import { mockSolEvmChainId } from '../config/sol';
import { mockTonChainId } from '../config/ton';
import {
  btc,
  solana,
  tomoChains,
  tomoEVMChains,
  ton,
} from '../providers/web3Provider/chains';
import { getChainId } from '../providers/web3Provider/chainUtils';
import { IChainId } from '../state/type';
import useChainConfig from './useChainConfig';

const useChains = () => {
  const { data } = useChainConfig();

  const chainIds = tomoChains
    .map(chain => {
      return getChainId(chain);
    })
    .filter(item => typeof item === 'number');

  const swapChainIds = [
    // 0,
    1,
    501,
    56,
    42_161,
    8453,
    81457,
    43_114,
    137,
    534_352,
    10,
    59_144,
    8333,
  ];

  const getChain = (chainId: number) => {
    if (chainId === mockSolEvmChainId) {
      return solana;
    }
    if (chainId === mockBtcEvmChainId) {
      return btc;
    }
    if (chainId === mockTonChainId) {
      return ton;
    }

    return tomoEVMChains.find(tomoChain => {
      return tomoChain.chain.id === chainId;
    });
  };

  const getChainIdByName = (
    value: string | undefined
  ): IChainId | undefined => {
    if (data && value) {
      for (const [key, val] of Object.entries(data.chain_id_name)) {
        if (val === value) {
          return Number(key == '607' ? '1100' : key) as IChainId;
        }
      }
    }
    return undefined;
  };

  const getChainNameById = (chainId: IChainId | undefined) => {
    if (data && chainId) {
      return data.chain_id_name[chainId];
    }
    return undefined;
  };

  return {
    evmChains: tomoEVMChains,
    getChainId,
    getChain,
    chains: tomoChains,
    chainIds,
    swapChainIds,
    getChainIdByName,
    getChainNameById,
  };
};

export default useChains;
